import { memo, useState } from "react";

import { Widget } from "@typeform/embed-react";

import { useLocalStorage, useUser } from "@cobliteam/hooks";
import useFeatureFlags from "@cobliteam/hooks/src/useFeatureFlags";

import { Button, Dialog } from "@cobliteam/ui/components";

const FORM_ID = "ybeZRhyY";
const localStorageResearchKey = "speeding-quality-research-responded";

type ResearchResponseStates = "first-showed" | "done";

const SpeedingQualityResearchModal = () => {
  const { session } = useUser();
  const [researchResponseState, setResearchResponseState] = useLocalStorage<
    ResearchResponseStates | undefined
  >(localStorageResearchKey);
  const { useSpeedEventsOsmTestAB } = useFeatureFlags();

  const triggerResearch =
    researchResponseState !== "done" && (useSpeedEventsOsmTestAB || false);
  const [open, setOpen] = useState(triggerResearch);

  const buttonText = researchResponseState ? "Cancelar" : "Responder depois";

  const onClose = (newOpenState: boolean) => {
    if (!newOpenState) {
      setOpen(false);

      if (researchResponseState) {
        setResearchResponseState("done");
      } else {
        setResearchResponseState("first-showed");
      }
    }
  };

  const onSubmit = () => {
    setResearchResponseState("done");
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <Dialog.Content modalSize="md">
        <Dialog.Header>
          <Dialog.Title>Queremos saber sua opinião!</Dialog.Title>
          <Dialog.Close />
        </Dialog.Header>

        <Widget
          id={FORM_ID}
          onSubmit={onSubmit}
          className="h-[500px]"
          hidden={{
            user_id: session?.user.id || "",
            fleet_id: session?.fleet.id || "",
            is_test_group: (useSpeedEventsOsmTestAB || false).toString(),
          }}
        />
        <Dialog.Footer className="flex justify-end gap-4">
          <Dialog.Close asChild>
            <Button variant="text">{buttonText}</Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
};

export default memo(SpeedingQualityResearchModal);
